module.exports = {"430702001":"启明街道","430702002":"府坪街道","430702003":"穿紫河街道","430702004":"丹阳街道","430702005":"白马湖街道","430702006":"德山街道","430702007":"东江街道","430702008":"永安街道","430702009":"南坪街道","430702010":"长庚街道","430702011":"芷兰街道","430702012":"芙蓉街道","430702013":"柳叶湖街道","430702014":"七里桥街道","430702015":"樟木桥街道","430702100":"河洑镇","430702102":"白鹤镇","430702200":"芦荻山乡","430702204":"丹洲乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430702.json
// module id = 1870
// module chunks = 0